import React, { useContext } from 'react'
import * as styles from './profileCover.css'
import { Avatar, CaptionText } from '@paypalcorp/pp-react'
import { formatMessage } from '../../../utils/localization/format_worldready'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import getNameInitials from '../../../utils/strings/getNameInitials'
import { isDetailsV1Dot1Enabled } from '../../../utils/features'
import { useLocalizedContent } from '../../../hooks/useLocalizedContent'

interface ProfileCoverProps {
  creator: {
    creatorName: string
    profileImage: string
    givenName: string
    surname: string
  }
}

const ProfileCover: React.FC<ProfileCoverProps> = (props) => {
  const useDetailV1Dot1Style = isDetailsV1Dot1Enabled()
  const { getContent } = useLocalizedContent()
  const { creator } = props

  const worldReadyC = useContext(WorldReadyContext)

  const formattedCreatedBy: string = formatMessage({
    worldReady: worldReadyC,
    contentId: `detail.createdBy`,
    formatOptions: { creatorName: creator.creatorName },
  })

  const creatorInitials =
    creator?.creatorName && getNameInitials(creator.givenName, creator.surname)

  const renderAvatar = (link: string, initials: string) => (
    <Avatar
      alt=""
      src={link}
      className={styles.profileAvatar}
      initials={initials}
      data-testid="profileCoverAvatar"
      size="sm"
      aria-hidden="true"
    />
  )

  const creatorNameClassName = useDetailV1Dot1Style
    ? styles.creatorNameMediumContrast
    : styles.creatorName

  return (
    <>
      {creator.creatorName && (
        <div
          className={styles.profileCoverStyles}
          data-testid="creatorContainer"
        >
          <div className={styles.innerContainerProfStyles}>
            {renderAvatar(creator.profileImage, creatorInitials)}
          </div>
          <div className={styles.innerCreatorDiv}>
            <CaptionText
              as="p"
              data-testid="profileCoverCreatorName"
              className={creatorNameClassName}
              aria-label={getContent('detail.poolOwner', {
                formattedCreatedBy,
              })}
            >
              {formattedCreatedBy}
            </CaptionText>
          </div>
        </div>
      )}
    </>
  )
}

export default ProfileCover
